import Moment from 'moment'
export const dateFilter = (val) => {
  return Moment(val).format('YYYY-MM-DD')
}

export const timeFilter = (val) => {
  return Moment(val).format('YYYY-MM-DD HH:mm:ss')
}


// WEBPACK FOOTER //
// ./src/assets/js/filters.js